<template>
  <div style="text-align: left">
    <pre>{{ currentData }}</pre>
    <pre>{{ currentSummary }}</pre>
  </div>
</template>
<script>
    export default {
      computed: {
        currentData() {
          const data = {}
          Object.entries(this.$store.state.steps).forEach(([module_name, step]) => {
            data[module_name] = {}
            console.log(module_name, JSON.stringify(step))
            Object.entries(step.userInputs).forEach(([key, value]) => {
              if (Array.isArray(value)) {
                let subdata = []
                value.forEach(i => subdata.push(i));
                data[module_name][key] = subdata
              } else {
                data[module_name][key] = value
              }
            });
          })
          return JSON.stringify(data,null,2)
        },
        currentSummary() {
          const data = {}
          Object.entries(this.$store.state.steps).forEach(([module_name, step]) => {
            data[module_name] = step.summary
          })
          return JSON.stringify(data,null,2)
        },
      }
    }
</script>